interface AI360ChartInstance {
  displayDefaultTooltip: () => void
}

const instances = new Set<AI360ChartInstance>()

/**
 * Tracks the mounted AI360 chart instances (line chart + mode timelines) that share a syncId.
 * Lets us re-trigger recharts' own "show tooltip at defaultIndex" logic on all of them at once,
 * e.g. to snap the cursor back to the current time when the mouse leaves any one of the charts.
 */
export const ChartInstanceRegistry = {
  register: (instance: AI360ChartInstance): (() => void) => {
    instances.add(instance)
    return () => instances.delete(instance)
  },

  resetAllToDefaultTooltip: (): void => {
    for (const instance of instances) {
      instance.displayDefaultTooltip()
    }
  },
}
